import { Link } from "react-router-dom";
import sign from '../assets/sign.svg';
import '../styles/supportButton.scss';

export const SupportButton = () =>{
  return <Link to='/support' className="support-btn" >
    <img src={sign} alt="" />
    <p >Support</p>
  </Link>
}